import React from 'react'

const EvaluatePlanned = () => {
  return (
    <div>You currently have no planned activities.</div>
  )
}

export default EvaluatePlanned